import { NetworkMidLevelComponent } from './network-mid-level.component';
import { NetworkDashboardRollupTableModule } from '../network-dashboard-rollup-table/network-dashboard-rollup-table.module';
import { NetworkMidLevelDataService } from './network-mid-level-data/network-mid-level-data.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NetworkDashboardMadlibModule } from './network-dashboard-mad-lib/network-dashboard-mad-lib.module';
import { NetworkMidLevelVizModule } from './network-mid-level-viz/network-mid-level-viz.module';

@NgModule({
  declarations: [NetworkMidLevelComponent],
  imports: [CommonModule, NetworkDashboardRollupTableModule, NetworkDashboardMadlibModule, NetworkMidLevelVizModule],
  exports: [NetworkMidLevelComponent],
  providers: [NetworkMidLevelDataService],
})
export class NetworkMidLevelModule {
  //
}
